window.addEventListener('load', function() {
    var host = window.location.hostname.replace(/^www\./, '');

    $('a[href]').each(function() {
        var el = this;
        var href = el.getAttribute('href');
        if (!href || el.classList.contains('no-auto-icon')) return;

        var hrefLower = href.toLowerCase();

        // Mail
        if (hrefLower.startsWith('mailto:')) {
            el.classList.add('is-mail');
            return;
        }

        // Phone
        if (hrefLower.startsWith('tel:')) {
            el.classList.add('is-phone');
            return;
        }

        // Skip: Anchor + JS
        if (hrefLower.startsWith('#') ||
            hrefLower.startsWith('javascript:')) {
            return;
        }

        var url;
        try { url = new URL(href, window.location.origin); } catch (e) { return; }
        var linkHost = url.hostname.replace(/^www\./, '');

        if (linkHost !== host) el.classList.add('is-external');

        if (el.hasAttribute('download') ||
            /\.(pdf|zip|rar|7z|docx?|xlsx?|pptx?)$/i.test(url.pathname)) {
            el.classList.add('is-download');
        }
    });
});
